module.exports = __webpack_public_path__ + "static/media/10.07c2fe7d.jpg";